import React from 'react';
import { ImageTransformer } from '../../components';
import PageStructure from '../page-structure/PageStructure';

const ImageTransformerPage = () => {
  return (
    <PageStructure>
      <ImageTransformer />
    </PageStructure>
  );
};

export default ImageTransformerPage;
